<script>
import { Doughnut } from 'vue-chartjs';
export default {
  extends: Doughnut,
  props: {
    donut_values: Array,
  },
  methods: {
    render() {
      this.renderChart(
        {
          labels: [
            'Promoters',
            'Passives',
            'Detractors'
          ],
          datasets: [{
            data: this.donut_values,
            backgroundColor: [
              '#1ACD82',
              '#E9C068',
              '#C24845'
            ],
            hoverOffset: 4,
          }]
        },
        {
          legend: {
            display: false,
          },
          cutoutPercentage: 85
        }
      )
    }
  },
  mounted () {
    this.render();
  }
}
</script>
